import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_INVESTORS } from "../../../config/api";

export const getStockInvestors = createAsyncThunk(
  "stocks/getInvestors",
  async (arg = {}, { rejectWithValue }) => {
    const { id, ...queryParams } = arg || {};
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_INVESTORS(id),
        queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
